<template>
  <div class="fixed inset-0 bg-slate-900/60 z-50 flex items-center justify-center p-4" @click.self="$emit('close')" role="dialog" aria-modal="true">
    <div class="bg-white rounded-q4cl shadow-card-hover w-full max-w-lg border border-q4cl-border max-h-[80vh] flex flex-col">
      <header class="px-5 py-3 border-b border-q4cl-border flex items-center justify-between flex-shrink-0">
        <h3 class="font-bold text-q4cl-primary">{{ $t(title) }}</h3>
        <button class="btn-icon" type="button" @click="$emit('close')" :aria-label="$t('閉じる')"><i class="fa-solid fa-xmark" aria-hidden="true"></i></button>
      </header>
      <div class="flex-1 overflow-y-auto p-5 prose prose-sm max-w-none" v-html="rendered"></div>
      <footer class="px-5 py-3 border-t border-q4cl-border flex justify-end flex-shrink-0">
        <button type="button" class="btn-primary" @click="$emit('close')">{{ $t('閉じる') }}</button>
      </footer>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ModalInfo',
  props: {
    title: { type: String, default: '情報' },
    content: { type: String, default: '' }
  },
  emits: ['close'],
  setup(props) {
    const i18n = window.i18nStore;
    const rendered = Vue.computed(() => {
      try {
        // 本文 markdown も翻訳通す (description 同様)
        const translated = i18n ? i18n.i18n(props.content || '') : (props.content || '');
        let html = DOMPurify.sanitize(marked.parse(translated));
        // 旧旧版踏襲 (ModalInfo.vue:57-60): href が #/ で始まる内部リンクは新タブで開かない
        // (外部リンクのみ target=_blank を付ける)
        html = html.replace(/(<a\b)([^>]*)>/g, (m, p1, p2) => {
          if (/href=['"]#\//.test(p2)) return p1 + p2 + '>';
          if (/\btarget\s*=/.test(p2)) return p1 + p2 + '>';
          return p1 + p2 + ' target="_blank" rel="noopener">';
        });
        return html;
      } catch (e) { return props.content; }
    });
    return { rendered };
  }
};
</script>
